import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('thumbnail', {
  root: {
    variants: {
      size: ['tiny', 'small', 'medium'],
      skin: ['primary', 'secondary'],
      textPosition: ['outside', 'inside'],
      contentAlignment: ['top', 'center'],
    },
    states: [
      'selected',
      'disabled',
      'border',
      'hasBackground',
      'hasChildren',
      'noPadding',
    ],
  },
  wrapper: {},
  selectedIcon: {},
  customChild: {},
  backgroundContainer: {},
  backgroundImage: {},
  contentContainer: {},
  imageContainer: {},
  image: {},
  textContent: {},
  title: {},
  description: {},
  bottomTitle: {},
});
